@if (ctas().length) {
  <div
    class="fb-cta-list"
    [class.fb-cta-list_wrap]="layout() === 'wrap'"
    [attr.data-cta-surface]="surface()"
  >
    @for (cta of ctas(); track cta.id) {
      <button
        type="button"
        puButton
        uiType="secondary"
        size="m"
        class="fb-cta-list__item"
        [attr.data-cta-id]="cta.id"
        [disabled]="disabled()"
        (click)="ctaSelected.emit(cta)"
      >
        {{ cta.labelKey | translateIn }}
      </button>
    }
  </div>
}
